/**
 * Input for b2Distance.
 * You have to option to use the shape radii
 * in the computation. Even
 */
var b2DistanceInput = /** @class */ (function () {
    function b2DistanceInput() {
        this.__fast__ = true;
    }
    return b2DistanceInput;
}());
export { b2DistanceInput };
